// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  adminPortal: {
    appId: '84b04f56-6011-4164-9f14-a05a0e56d9fa',
    appSecret: '1ad0869080087b2b52b2727b2bd79f6f',
    baseUrl: 'https://stage-admin.smartdirectre.com/api'
  },
  apiKeys: {
    revenueCat: {
      android: 'goog_DSrJigWPsCquMqCKaHjVGTdkyGi',
      ios: 'appl_lezrhzRokAwDIIsoKiwrjvMAlme',
      web: 'strp_wlwQucCHEysihcLDvFdVDIqBOlH'
    },
    stripe: {
      publicKey:
        'pk_test_51Jx3BDHc5vpwpDJ3qOigkqR9bQ6ogQsn4M3qdNTWVS5NRMgwha9EokPqLDeoqCyE68JEgQmmUAyRA1QuBLALYKUc00bx3jJRMi'
    }
  },
  colors: {
    primary: '#003b3f',
    secondary: '#b0b1c1'
  },
  container: 'smartdirect',
  loggerHostname: 'smartdirect-mobile-prototype',
  production: false,
  propertyForce: {
    baseUrl: 'https://test.propertyforcemobile.com/v4test/TitleService.svc/Secure'
  },
  report: {
    appId: '84b04f56-6011-4164-9f14-a05a0e56d9fa',
    appSecret: '1ad0869080087b2b52b2727b2bd79f6f',
    baseUrl: 'https://stage-report-service.smartdirectre.com/api'
  },
  tutorialsUrl: 'https://redshedtechnology.com/sdtutorials'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
